import { FC, SyntheticEvent } from "react";
import classNames from "classnames";
import styles from "./Switch.module.scss";

type Props = {
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  classes?: {
    root?: string;
  };
};

const Switch: FC<Props> = ({
  label,
  checked = false,
  disabled = false,
  onChange,
  classes,
}) => {
  const handleClick = (e: SyntheticEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (disabled) return;
    onChange?.(!checked);
  };

  return (
    <div
      onClick={handleClick}
      className={classNames(styles.root, classes?.root, {[styles.disabled]: disabled})}
    >
      {label && <div className={styles.label}>{label}</div>}
      <div
        className={classNames(styles.track, {[styles.checked]: checked})}
      >
        <div className={styles.thumb} />
      </div>
    </div>
  );
};

export default Switch;
